
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Curriculumleft from '../Curriculum/Curriculumleft';

const AcademicCalenderEle = () => {
    const curriculumData = [
        {
            department: 'Chemistry',
            curricula: [
                {
                    batch: '2020–21 onwards',
                    url: 'https://files.iittp.ac.in/pdfs/curriculum/2022/Msc/M.Sc-CY-2020-21.pdf',
                },
            ],
        },
        {
            department: 'Mathematics',
            curricula: [
                {
                    batch: '2025 batch onwards',
                    url: 'https://files.iittp.ac.in/pdfs/curriculum/2023/MA/MSc_Mathematics.pdf',
                },
            ],
        },
        {
            department: 'Mathematics & Statistics',
            curricula: [
                {
                    batch: '2023 batch onwards',
                    url: 'https://files.iittp.ac.in/pdfs/curriculum/2023/MA/MSc-MA-2023-24%20onwards_03-01-2024.pdf',
                },
                {
                    batch: '2019 batch onwards',
                    url: 'https://files.iittp.ac.in/pdfs/curriculum/2022/Msc/M.Sc-MA-2019-20.pdf',
                },
            ],
        },
        {
            department: 'Physics',
            curricula: [
                {
                    batch: '2026 batch onwards',
                    url: 'https://files.iittp.ac.in/2026/academic/curriculum/M.Sc-PH-2026-27.pdf',
                },
                {
                    batch: '2020 batch onwards',
                    url: 'https://files.iittp.ac.in/pdfs/curriculum/2022/Msc/M.Sc-PH-2020-21.pdf',
                },
            ],
        },
    ];

    return (
        <section className="project-detail">
            <Container>
                <Row>
                    <Col
                        md={4}
                        className="c-left custom-padding-color mb-4"
                    >
                        <Curriculumleft activeIndex={3} />
                    </Col>

                    <Col md={8} className="c-right mt-2 ps-5">
                        <h3 className="text-center mb-5">
                            M.Sc. Curriculum
                        </h3>

                        <h5>
                            Curricula for M.Sc. programmes are listed below:
                        </h5>

                        <table className="table table-bordered table-hover align-middle mt-4">
                            <thead className="table-primary text-center">
                                <tr>
                                    <th width="10%">S.No.</th>
                                    <th width="45%">Department / Programme</th>
                                    <th width="45%">Batch</th>
                                </tr>
                            </thead>

                            <tbody>
                                {curriculumData.map((department, index) =>
                                    department.curricula.map(
                                        (item, itemIndex) => (
                                            <tr
                                                key={`${index}-${itemIndex}`}
                                                className={
                                                    index % 2 === 0
                                                        ? 'table-light'
                                                        : 'table-secondary'
                                                }
                                            >
                                                {itemIndex === 0 && (
                                                    <>
                                                        <td
                                                            rowSpan={
                                                                department
                                                                    .curricula
                                                                    .length
                                                            }
                                                            className="text-center align-middle fw-bold"
                                                        >
                                                            {index + 1}
                                                        </td>

                                                        <td
                                                            rowSpan={
                                                                department
                                                                    .curricula
                                                                    .length
                                                            }
                                                            className="align-middle fw-bold"
                                                        >
                                                            {
                                                                department.department
                                                            }
                                                        </td>
                                                    </>
                                                )}

                                                <td>
                                                    <Link
                                                        to={item.url}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="text-decoration-none"
                                                    >
                                                        <i className="fas fa-file-pdf text-danger me-2"></i>
                                                        {item.batch}
                                                    </Link>
                                                </td>
                                            </tr>
                                        )
                                    )
                                )}
                            </tbody>
                        </table>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default AcademicCalenderEle;
